import { FC, useMemo } from 'react';
import { FiUserPlus } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { PageContainer } from '../../../components/page/PageContainer';
import { PageHeader } from '../../../components/page/PageHeader';
import { PageSizer, SizerMode } from '../../../components/page/PageSizer';
import { Permissions, useAuthenticationService } from '../../../services/authentication/authentication-service';
import { handleError } from '../../../services/gql/config/URQLProvider';
import { ReadEmployee, useGetEmployeesByLocationsQuery, useGetStaffByIdQuery } from '../../../services/gql/graphql.generated';
import { useLocationService } from '../../../services/location/LocationService';
import strings from '../team.translations';
import { AddSingleTeamMemberForm } from './AddSingleTeamMemberForm';

export const AddTeamMemberPage: FC = () => {
  const [permissions] = useAuthenticationService(state => [state.user?.profile.permission]);
  const canCreateEmployee = permissions?.includes(Permissions.EmployeeCreate) ?? false;
  const locationList = useLocationService(state => state.locationList);
  const locationIds = locationList.map(location => location.id);

  const [{ error }, getStaffQuery] = useGetEmployeesByLocationsQuery({
    variables: { locationIds },
    pause: locationIds.length === 0,
    context: useMemo(
      () => ({
        suspense: false
      }),
      []
    )
  });
  if (error) handleError(error);

  const breadcrumbs = [
    {
      name: strings.teamPageTitle,
      to: '/team'
    },
    {
      name: strings.addTeamMenu.addATeamMember,
      to: '/team/add-team-member'
    }
  ];

  const { userId } = useParams<'userId'>();

  const [{ data: userData }] = useGetStaffByIdQuery({
    variables: {
      id: userId
    },
    requestPolicy: 'network-only'
  });

  return (
    <PageContainer>
      <PageHeader icon={<FiUserPlus />} pageTitle={strings.addTeamMenu.addATeamMember} breadcrumbs={breadcrumbs} />
      <PageSizer mode={SizerMode.PAGE}>
        <div className="py-5">
          {canCreateEmployee && (
            <AddSingleTeamMemberForm
              refetchCallback={getStaffQuery}
              employee={userData?.employee as ReadEmployee}
            />
          )}
        </div>
      </PageSizer>
    </PageContainer>
  );
};
